import productModule from '../scripts/product/product.module.js';

import '../styles/partials/modal-video.scss';

import appDependency from '../scripts/appDependency.js';

appDependency.addItem(productModule);
